export interface ScreenApiDefinition {
  id: string;
  endpoint: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  onLoad: boolean;
  /** Optional additions/overrides; an empty object inherits all system defaults. */
  headers: Record<string, string>;
  query: Record<string, unknown>;
  payload: unknown;
  /** State key to response path, e.g. customers: data.items. Empty path selects the entire response. */
  responseMapping: Record<string, string>;
}

export const screenStateKey = (key: string): boolean => /^[a-zA-Z][a-zA-Z0-9_]*$/.test(key) && !['constructor', 'prototype', '__proto__'].includes(key);

export function readScreenPath(value: unknown, path: string): unknown {
  let current: any = value;
  for (const key of path ? path.split('.') : []) {
    if (['constructor', 'prototype', '__proto__'].includes(key)) return undefined;
    current = current != null && Object.hasOwn(Object(current), key) ? current[key] : undefined;
  }
  return current;
}

export function validateScreenApis(value: unknown): asserts value is ScreenApiDefinition[] {
  if (!Array.isArray(value)) throw new Error('API definitions must be a list.');
  const ids = new Set<string>();
  for (const api of value) {
    if (!api || typeof api.id !== 'string' || !screenStateKey(api.id) || ids.has(api.id)
      || typeof api.endpoint !== 'string' || !/^(https?:\/\/[^\s]+|\/(?!\/)[^\s]*)$/.test(api.endpoint)
      || !['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].includes(api.method) || typeof api.onLoad !== 'boolean') throw new Error('Each API needs a unique simple name, a valid endpoint and method.');
    ids.add(api.id);
    for (const field of ['headers', 'query', 'responseMapping']) {
      if (!api[field] || typeof api[field] !== 'object' || Array.isArray(api[field])) throw new Error(`API ${api.id}: ${field} must be an object.`);
    }
    if (!Object.values(api.headers).every(item => typeof item === 'string') || !Object.entries(api.responseMapping).every(([key, path]) => screenStateKey(key) && typeof path === 'string')) throw new Error(`API ${api.id}: invalid headers or response mapping.`);
  }
}
